<div class="col-12">
  <a (click)="onGoBack()"
    class="btn btn--link btn--link--secondary btn--link--secondary--bold btn--link--secondary--big btn--link--secondary--left pl-0">
    <img class=" title-navigation-fix-align" src="assets/img/arrow_l_g.png" alt="">Aprobar solicitud</a>
</div>

<div class="col-12">
  <app-form-employee
    [assetId]="this.assetId"
    [enabled]="true"
    [controlForm]="formGroupEmployeeControl"
    colorBoxes="white"
    [showTitle]="false"
    [isEmployee]="false"
  >
  </app-form-employee>
</div>

<div class="col-12 u-mt30 mb-2">
  <button
    (click)="onSubmit()"
    type="button"
    class="btn btn--primary modal__trigger px-5"
    data-modal="modal01"
    [attr.disabled]="formGroup.valid && formGroupEmployeeControl.valid ? null : true"
  >
    Registrar
  </button>
</div>
